import { FormikProps } from 'formik';
import cc from 'classcat';
import { ChangeEvent, useState } from 'react';

interface TextAreaFormikProps<T> {
    id: string;
    placeholder?: string;
    label?: string;
    isRequired?: boolean;
    onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
    className?: string;
    maxLength?: number;
    context: FormikProps<T>;
    testId?: string;
    disabled?: boolean;
}

export const TextAreaFormik = <T extends object>({
    id,
    placeholder,
    label,
    isRequired,
    onChange,
    className,
    context,
    maxLength,
    testId,
    disabled = false,
}: TextAreaFormikProps<T>) => {
    const { values, handleChange, touched, errors } = context;

    const [isFocused, setIsFocused] = useState<boolean>(false);
    const isError = () => {
        return touched[id as keyof T] && errors[id as keyof T];
    };

    return (
        <div className={cc(['text-area', className, { 'text-area--disabled': disabled }])}>
            {label && (
                <label className="text-area__label paragraph-4">
                    {label}
                    {isRequired ? <span className="text-area_is_req">*</span> : ''}
                </label>
            )}
            <textarea
                className={cc(['text-area__field', { 'text-area__field--disabled': disabled }])}
                id={id}
                name={id}
                value={values[id as keyof T] as string}
                placeholder={placeholder}
                onFocus={() => !disabled && setIsFocused(true)}
                onBlur={() => !disabled && setIsFocused(false)}
                onChange={disabled ? undefined : onChange ?? handleChange}
                maxLength={maxLength}
                data-testid={testId}
                disabled={disabled}
            />

            {isError() && isFocused && <p className="input__error-message">{errors[id as keyof T] as string}</p>}
        </div>
    );
};
